import { useDisclosure } from '@heroui/modal';
import { LuPlus } from 'react-icons/lu';
import { Alert } from '@heroui/alert';
import { Button } from '@heroui/button';
import { BiSolidBookBookmark } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';

import { useSongbooks } from '@/hooks/useSongbook.ts';

import ImportButton from '../components/ImportButton.tsx';

import Songbook from './Songbook.tsx';
import SongbookCreateModal from './SongbookCreateModal.tsx';

function SongbookList() {
  const { t } = useTranslation();
  const { isLoading, data } = useSongbooks();
  const disclosure = useDisclosure({ id: 'songbook' });

  if (isLoading || !data) return null;

  return (
    <div className="flex flex-wrap gap-8 flex-col">
      {data.length === 0 ? (
        <div className="flex justify-center grow">
          <div className="py-8">
            <Alert
              description={t('songbook.home.createDescription')}
              endContent={
                <div className="flex gap-1 items-center ml-4">
                  <ImportButton />
                  <span>
                    {t('media.file.dragOr')}
                  </span>
                  <Button color="secondary" variant="flat" onPress={disclosure.onOpen}>
                    {t('songbook.home.createButton')}
                  </Button>
                </div>
              }
              icon={<BiSolidBookBookmark />}
              title={t('songbook.home.createTitle')}
              variant="faded"
            />
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-between">
          <Button color="primary" startContent={<LuPlus />} variant="solid" onPress={disclosure.onOpen}>
            {t('songbook.home.add')}
          </Button>
        </div>
      )}
      <div className="flex flex-wrap gap-8">
        {data.map((book) => (
          <Songbook key={book.id} songbook={book} />
        ))}
      </div>
      <SongbookCreateModal disclosure={disclosure} />
    </div>
  )
}

export default SongbookList;
